import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useTenant } from "../../../Contexts/TenantContext";
import { orderService } from "../../../Api/Services/orderService";
import { customerService } from "../../../Api/Services/customerService";
import { whatsAppService } from "../../../Api/Services/whatsAppService";
import { formatCnpj } from "../../../Utils/DataFormatters";
import { toast } from "react-toastify";
import SmartNavbar from "../../../Components/SmartNavbar/SmartNavbar";
import Button from "../../../Components/Button/Button";

const OperatorHomePage = () => {
  const { tenant, tenantContact } = useTenant();

  const navigate = useNavigate();

  const [orderCount, setOrderCount] = useState(0);
  const [customerCount, setCustomerCount] = useState(0);
  const [messageCount, setMessageCount] = useState(0);

  const getOrderCount = useCallback(async () => {
    try {
      const count = await orderService.getCount();
      setOrderCount(count);
    } catch (error) {
      toast.error("Erro ao buscar número de pedidos.");
    }
  }, []);

  const getCustomerCount = useCallback(async () => {
    try {
      const count = await customerService.getCount();
      setCustomerCount(count);
    } catch (error) {
      toast.error("Erro ao buscar número de clientes.");
    }
  }, []);

  const getMessageCount = useCallback(async () => {
    try {
      const count = await whatsAppService.getMessageCount();
      setMessageCount(count);
    } catch (error) {
      toast.error("Erro ao buscar número de mensagens.");
    }
  }, []);

  useEffect(() => {
    void getOrderCount();
    void getCustomerCount();
    void getMessageCount();
  }, [getCustomerCount, getMessageCount, getOrderCount]);

  return (
    <div>
      <SmartNavbar />
      <main className={`max-w-6xl mx-auto py-10 px-6 `}>
        <h1 className="text-2xl font-bold mb-4">{"Bem-vindo!"}</h1>

        <section className={`mb-6 p-4 border shadow-sm bg-white rounded`}>
          <h2 className="text-lg font-semibold mb-2">{"Informações da Empresa:"}</h2>
          <ul className="text-sm text-gray-700">
            <li><strong>{"Nome"}:</strong> {tenant.companyName}</li>
            {tenant.cnpj && (
              <li><strong>CNPJ:</strong> {formatCnpj(tenant.cnpj)}</li>
            )}
            <li><strong>Email:</strong> {tenantContact.email}</li>
          </ul>
        </section>

        <section className="mb-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className={`p-4 border bg-white shadow-sm text-center rounded`}>
            <h3 className="text-xl font-bold">{orderCount}</h3>
            <p className="text-sm text-gray-600">{"Pedidos"}</p>
          </div>
          <div className={`p-4 border bg-white shadow-sm text-center rounded`}>
            <h3 className="text-xl font-bold">{customerCount}</h3>
            <p className="text-sm text-gray-600">{"Clientes"}</p>
          </div>
          <div className={`p-4 border bg-white shadow-sm text-center rounded`}>
            <h3 className="text-xl font-bold">{messageCount}</h3>
            <p className="text-sm text-gray-600">{"Mensagens WhatsApp"}</p>
          </div>
        </section>

        <section className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Button
            onClick={() => navigate("/operador/pedidos")}
            className="w-full py-4"
          >
            {"Ver Pedidos"}
          </Button>
          <Button
            onClick={() => navigate("/operador/clientes")}
            className="w-full py-4"
          >
            {"Gerenciar clientes"}
          </Button>       
          <Button
            onClick={() => navigate("/operador/whatsapp")}
            className="w-full py-4"
          >
            {"Ver WhatsApp"}
          </Button>
        </section>
      </main>
    </div>
  );
};

export default OperatorHomePage;
